<div class="banner-boxes-area">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-banner-boxes">
          <div class="icon">
            <i-feather name="message-square"></i-feather>
          </div>
          <h3 i18n="@@step1HowItWorksLanding">Tell us what you need</h3>
          <p i18n="@@step1HowItWorksDescriptionLanding">
            Briefly describe the service you are looking for, don't forget to mention whether it's online or in person,
            your budget and when do you need it for.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-banner-boxes">
          <div class="icon">
            <i-feather name="clipboard"></i-feather>
          </div>
          <h3 i18n="@@step2HowItWorksLanding">Get quotes from different suppliers</h3>
          <p i18n="@@step2HowItWorksDescriptionLanding">
            We will find the best service providers near you or online, notify them about your request and they will
            send you quotes for you to analyse.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-banner-boxes">
          <div class="icon">
            <i-feather name="check-square"></i-feather>
          </div>
          <h3 i18n="@@step3HowItWorksLanding">Accept the proposal and get the work done</h3>
          <p i18n="@@step3HowItWorksDescriptionLanding">
            Review all the received quotes, ask all the questions you have before accepting any and once you are ready,
            pick the best candidate for the job.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
